import { useLang } from "../i18n/LangContext";
import { useReveal } from "../hooks/useReveal";

export default function Partners() {
    const { t } = useLang();
    const p = t.partners;
    const head = useReveal();
    // Duplicate the list for seamless infinite marquee
    const marquee = [...p.list, ...p.list];

    return (
        <section
            data-testid="partners-section"
            className="py-24 md:py-32 bg-paper-alt overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div ref={head.ref} className={`${head.className} max-w-3xl mb-12`}>
                    <div className="flex items-center gap-3 mb-6">
                        <span className="w-10 h-px bg-ink" />
                        <span className="font-display text-xs uppercase tracking-[0.3em] text-ink-muted">
                            {p.kicker}
                        </span>
                    </div>
                    <h2 className="font-display font-bold uppercase text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight text-ink">
                        {p.title}
                    </h2>
                    <p className="mt-6 text-base md:text-lg text-ink-soft max-w-2xl">
                        {p.subtitle}
                    </p>
                </div>
            </div>

            {/* Marquee row 1 */}
            <div className="relative">
                <div className="flex gap-3 marquee-track py-3">
                    {marquee.map((name, i) => (
                        <span
                            key={`a-${i}`}
                            data-testid={i < p.list.length ? `partner-${i}` : undefined}
                            className="flex-shrink-0 inline-flex items-center justify-center bg-white border border-ink/15 px-6 py-3 font-display text-sm uppercase tracking-widest text-ink whitespace-nowrap hover:border-mint hover:bg-mint-soft transition-colors"
                        >
                            {name}
                        </span>
                    ))}
                </div>
            </div>

            {/* Marquee row 2 (reverse direction, slight offset) */}
            <div className="relative mt-3">
                <div className="flex gap-3 marquee-track-reverse py-3">
                    {marquee
                        .slice()
                        .reverse()
                        .map((name, i) => (
                            <span
                                key={`b-${i}`}
                                className="flex-shrink-0 inline-flex items-center justify-center bg-white border border-ink/15 px-6 py-3 font-display text-sm uppercase tracking-widest text-ink whitespace-nowrap hover:border-mint hover:bg-mint-soft transition-colors"
                            >
                                {name}
                            </span>
                        ))}
                </div>
            </div>
        </section>
    );
}
